import { graphql } from "react-relay";

export const load_term_dates = graphql`
  query LoadTermDatesQuery($schoolId: ID, $startingYear: Int!, $skipSchoolTermDates: Boolean!) {
    termDates(startingYear: $startingYear) {
      edges {
        node {
          id
          term
          firstDayOfTerm
          lastDayOfFirstHalfOfTerm
          firstDayOfSecondHalfOfTerm
          lastDayOfTerm
        }
      }
    }
    schoolTermDates: termDates(schoolId: $schoolId, startingYear: $startingYear)
      @skip(if: $skipSchoolTermDates) {
      __id
      edges {
        node {
          id
          term
          firstDayOfTerm
          lastDayOfFirstHalfOfTerm
          firstDayOfSecondHalfOfTerm
          lastDayOfTerm
        }
      }
    }
  }
`;
